import { apiRequest } from "../api/request";
import API_PATHS from "../api/paths";

export async function getFlashSaleDiscounts(filters) {
    return await apiRequest({
        url: API_PATHS.getFlashSaleDiscounts(filters),
        method: "GET",
    });
}

export async function saveFlashSaleDiscount(data) {
    return await apiRequest({
        url: API_PATHS.saveFlashSaleDiscount,
        method: "POST",
        data,
    });
}

export async function updateFlashSaleDiscount(id, data) {
    return await apiRequest({
        url: API_PATHS.updateFlashSaleDiscount(id),
        method: "PUT",
        data,
    });
}   

export async function deleteFlashSaleDiscount(id) {
    return await apiRequest({
        url: API_PATHS.updateFlashSaleDiscount(id),
        method: "DELETE",
    });
}